module.exports = __webpack_public_path__ + "8d8648ca6276a42ce3feb8876307e244.jpg";